import { render, staticRenderFns } from "./SidebarGroup.vue?vue&type=template&id=46660233"
import script from "./SidebarGroup.vue?vue&type=script&lang=js"
export * from "./SidebarGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports